import {
    FilterType,
} from 'app/enums/common.enums'
import {
    OrderStatuses,
    OrderTypes,
    ProductType,
} from 'app/enums/label.enums'
import {
    InboundOrdersType,
} from 'app/Apps/ContainerManagement/ServiceCenters/ScenarioEditor/ScenarioEditor.types'
import {
    ColumnConfigMappingType,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid'

const columns: ColumnConfigMappingType<InboundOrdersType>[] = [
    {
        name: 'orderNumber',
        labelKey: 'ORDER',
        componentName: 'OrderTableLink',
        width: 130,
    },
    {
        name: 'orderStatus',
        componentName: 'EnumValue',
        allowedValuesEnum: OrderStatuses,
        filterField: 'orderStatus',
        filterType: FilterType.Array,
        labelKey: 'ORDER_STATUS',
    },
    {
        name: 'orderType',
        componentName: 'EnumValue',
        allowedValuesEnum: OrderTypes,
        labelKey: 'ORDER_TYPE',
        filterField: 'orderType',
        filterType: FilterType.Array,
    },
    {
        name: 'from',
        labelKey: 'FROM',
    },
    {
        name: 'originLocationLocationName',
        filterField: 'originLocationLocationName',
        filterType: FilterType.Array,
        labelKey: 'ORIGIN_LOCATION',
    },
    {
        name: 'estimatedArrival',
        sorting: false,
        labelKey: 'ESTIMATED_DELIVERY',
    },
    {
        name: 'requiredContainers',
        componentName: 'RequiredContainersList',
        allowedValuesEnum: ProductType,
        sorting: false,
        labelKey: 'REQUIRED_CONTAINERS',
        filterField: 'requiredContainers',
        filterType: FilterType.Array,
        minWidth: 180,
    },
]

export default columns
